import React from 'react'; 
import './About.css';

import { Heading, Button } from '../../../components';
import { about } from '../../../constants';
   


const About = () => {    

  const { sub, heading, description, image, button } = about;

  return ( 
    <section className='about'> 

      <div className='box-container'> 
 
        {/* About images */}
        <img src={image.src} alt={image.alt} />

        {/* About content */}
        <div className='content'>
          <div className='text'>

            {/* About Heading */}
            <Heading title={heading} span={sub} sideHeading linear /> 

            {/* Description */}
            <p>{description}</p>

            {/* Button Component: Links to a specific page or action */}
            <Button link={button.link} title={button.text} />

          </div>
        </div>
 
      </div> 

    </section>
  )
}

export default About;